import * as Yup from 'yup';

export default Yup.object().shape({
  displayName: Yup.string()
    .matches(/^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/)
    .required('Please enter valid display name')
});
